export const createContextId = (): string => Math.random().toString(36).slice(-8)
